import { ProtectedRoute } from "../middleware/ProtectedRoute";
import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminIndexPage from "../pages/admin";
import AdminItemIndexPage from "../pages/admin/item";
import AdminStoreShowPage from "../pages/admin/store/show";
import AdminStorePlanItemsPage from "../pages/admin/store/plan-items";
import AdminStoreTweetPage from "../pages/admin/store/tweet";
import AdminStoreReportPage from "../pages/admin/store/report";
import SystemAdminIndexPage from "../pages/system-admin/index";
import SystemAdminCategoryIndexPage from "../pages/system-admin/category/index";
import SystemAdminItemIndexPage from "../pages/system-admin/item/index";
import SystemAdminStoreIndexPage from "../pages/system-admin/store/index";
import SystemAdminStoreInquiryIndexPage from "../pages/system-admin/store-inquiry/index";
import LoginPage from "../pages/login";
import ForgotPasswordPage from "../pages/forgot-password";
import ResetPasswordPage from "../pages/reset-password";

export const AppRoutes: React.FC = () => (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/login/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/admin/"
        element={
          <ProtectedRoute role="store">
            <AdminIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/item/"
        element={
          <ProtectedRoute role="store">
            <AdminItemIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/store/show"
        element={
          <ProtectedRoute role="store">
            <AdminStoreShowPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/store/plan-items"
        element={
          <ProtectedRoute role="store">
            <AdminStorePlanItemsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/store/tweet"
        element={
          <ProtectedRoute role="store">
            <AdminStoreTweetPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/store/report"
        element={
          <ProtectedRoute role="store">
            <AdminStoreReportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-admin"
        element={
          <ProtectedRoute role="system">
            <SystemAdminIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-admin/category"
        element={
          <ProtectedRoute role="system">
            <SystemAdminCategoryIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-admin/item"
        element={
          <ProtectedRoute role="system">
            <SystemAdminItemIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-admin/store"
        element={
          <ProtectedRoute role="system">
            <SystemAdminStoreIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-admin/store-inquiry"
        element={
          <ProtectedRoute role="system">
            <SystemAdminStoreInquiryIndexPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );